module.exports = __webpack_public_path__ + "img/step1-Voip.b5d6e441.png";